import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import './Loading.css';

class SmallLoading extends Component {
	render() {
		return (
			<div className="smallSpinWrap">
				<div className="smallSpin">
					<FontAwesome name="spinner" className="icon" />
				</div>
			</div>
		);
	}
}

export { SmallLoading };



// WEBPACK FOOTER //
// ./src/components/common/loading/SmallLoading.js